import * as api from "../api";
import axios from "axios";

let base = api.BaseApiUrl;

///获取需求列表
export const getDemandList = (params) => {
  return axios.get(`${base}/api/Demand`, { params: params });
};
///获取诉求详情
export const getDemandDetail = (params) => {
  return axios.get(`${base}/api/Demand/${params.id}`, { params: {} });
};
///更新诉求
export const updateDemandDetail = (data) => {
  return axios.put(`${base}/api/Demand`, data);
};
///更新诉求
export const deleteDemandDetail = (data) => {
  return axios.delete(`${base}/api/Demand`, { params: data });
};

// 获取QA列表
export const getFaqsByPage = (params) => {
  return axios.post(`${base}/api/Faqs/GetFaqsByPage`, params);
};
///新增QA数据
export const addFaqs = (params) => {
  return axios.post(`${base}/api/Faqs/AddFaqs`, params);
};
///更新QA数据
export const putFaqs = (data) => {
  return axios.put(`${base}/api/Faqs/PutFaqs`, data);
};
///删除QA数据
export const deleteFaqs = (params) => {
  return axios.delete(`${base}/api/Faqs/DeleteFaqs`, { params: params });
};
